// a JS script to auto play all videos when fully scrolled in viewport ( and have data-autoplay attribute / prop ) and pause when they leave the viewport
(function autoPlayVideosInViewport() {
    function autoPlayGalleryVideos() {
        const videoElements = document.querySelectorAll('[data-autoplay]');
        const galleryVideoObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                const videoElement = entry.target;
                if (entry.isIntersecting) {
                    if (videoElement) {
                        videoElement.paused && videoElement.play();
                    }
                } else {
                    if (videoElement && videoElement.pause) {
                        !videoElement.paused && videoElement.pause();
                    }
                }
            });
        }, {
            root: null,
            threshold: [0.6, 0.75],
        });

        videoElements.forEach((videoElement) => {
            galleryVideoObserver.observe(videoElement);
        });
    }

    document.addEventListener('DOMContentLoaded', () => {
        autoPlayGalleryVideos();
    });

})();
